import type { CalculatorObjectV2 } from "@bezpart-board/shared";
import { nextZIndex } from "../../editor/zIndex";
import {
  CALCULATOR_DEFAULT_STATE,
  CALCULATOR_VARIANT,
  type CalculatorVariant,
} from "./calculatorLogic";

/** Размер под раскладку как в Windows (5×7 + тригонометрия). */
export const CALCULATOR_DEFAULT_SIZE = { w: 420, h: 640 } as const;
export const GRAPH_UNITS_DEFAULT_SIZE = { w: 640, h: 560 } as const;

export type CreateCalculatorOptions = {
  variant?: CalculatorVariant;
};

/** Создаёт калькулятор, центрированный в (cx, cy). */
export function createCalculatorObject(
  cx: number,
  cy: number,
  existingObjects: { zIndex?: string }[] = [],
  opts: CreateCalculatorOptions = {}
): CalculatorObjectV2 {
  const variant = opts.variant ?? "calc";
  const { w, h } =
    variant === "graph_units" ? GRAPH_UNITS_DEFAULT_SIZE : CALCULATOR_DEFAULT_SIZE;
  const s = CALCULATOR_DEFAULT_STATE;
  const v = CALCULATOR_VARIANT[variant];
  return {
    id: crypto.randomUUID(),
    type: "calculator",
    x: Math.round(cx - w / 2),
    y: Math.round(cy - h / 2),
    w,
    h,
    mode: v.mode,
    enabledModes: [...v.enabledModes],
    expr: s.expr,
    display: s.display,
    history: s.history,
    angleMode: s.angleMode,
    secondMode: s.secondMode,
    graphExpr: s.graphExpr,
    graphRange: s.graphRange,
    graphSeries: s.graphSeries.map((row) => ({ ...row })),
    graphPoints: s.graphPoints.map((row) => ({ ...row })),
    convertCategory: s.convertCategory,
    convertFrom: s.convertFrom,
    convertTo: s.convertTo,
    convertValue: s.convertValue,
    zIndex: nextZIndex(existingObjects),
  };
}
